<template>
  <div class="main">
    <div class="tipinfo">
      本操作，用于将悦享工资条集成到客户自己的OA、HRMS等系统中。
    </div>
    <table border="1" width="650" height="150" cellspacing="0" style="border-collapse: collapse" cellpadding="10">
      <tr>
        <th colspan="3">1、获取API访问的AccessToken</th>
      </tr>
      <tr>
        <td>调用地址</td>
        <td>
          https://api.prosuntech.com/authority-center/open/get_access_token
        </td>
      </tr>
      <tr>
        <td>请求方式</td>
        <td>POST</td>
      </tr>
      <tr>
        <td>传参方式</td>
        <td>formdata</td>
      </tr>
      <tr>
        <td>传参</td>
        <td>username ：管理员账号 ，password：管理员账号的密码</td>
      </tr>
      <tr>
        <td>参数类型</td>
        <td>username ：String，password：String</td>
      </tr>
      <tr>
        <td>返回值说明</td>
        <td>code：状态码，msg:返回的消息信息，data：返回accesstoken的值</td>
      </tr>
      <tr>
        <td>返回对象</td>
        <td>JSON对象</td>
      </tr>
    </table>
    <table border="1" width="650" height="150" cellspacing="0" style="border-collapse: collapse" cellpadding="10">
      <tr>
        <th colspan="3">2、员工工资列表分页查询</th>
      </tr>
      <tr>
        <td>调用地址</td>
        <td>
          https://api.prosuntech.com/salary-service/open/api/salary/page
        </td>
      </tr>
      <tr>
        <td>请求方式</td>
        <td>GET</td>
      </tr>
      <tr>
        <td>传参方式</td>
        <td>Params</td>
      </tr>
      <tr>
        <td>传参</td>
        <td>
          token：accesstoken
          ，mobile：员工手机号，email：员工邮箱，pageNumber：分页页数，size:第几页（手机号和邮箱必须有一个传值）
        </td>
      </tr>
      <tr>
        <td>参数类型</td>
        <td>token：String，mobile：String，email：String，pageNumber：Int，size:Int</td>
      </tr>
      <tr>
        <td>返回值说明</td>
        <td>Totalcount：总条数，snedList:发送记录集合，name:员工姓名，email:员工邮箱号，mobile：员工手机号，year:年份，mouth：月份，content：加密后发送类容，id:主键id,sendTime：发送日期，salaryType：发薪类型</td>
      </tr>
      <tr>
        <td>返回对象</td>
        <td>JSON对象</td>
      </tr>
    </table>
    <table border="1" width="650" height="150" cellspacing="0" style="border-collapse: collapse" cellpadding="10">
      <tr>
        <th colspan="3">3、员工工资详情查询</th>
      </tr>
      <tr>
        <td>调用地址</td>
        <td>
          https://api.prosuntech.com/salary-service/open/api/salary/detail
        </td>
      </tr>
      <tr>
        <td>请求方式</td>
        <td>GET</td>
      </tr>
      <tr>
        <td>传参方式</td>
        <td>Params</td>
      </tr>
      <tr>
        <td>传参</td>
        <td>token：accesstoken ，id：工资列表中的id</td>
      </tr>
      <tr>
        <td>参数类型</td>
        <td>token：String，id:String</td>
      </tr>
      <tr>
        <td>返回值说明</td>
        <td>
          name:员工姓名，email:员工邮箱号，mobile：员工手机号，year:年份，mouth：月份，content：发送类容，id:主键id,sendTime：发送日期，
          salaryType：发薪类型
        </td>
      </tr>
      <tr>
        <td>返回对象</td>
        <td>JSON对象</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
.main {
  table {
    margin-bottom: 30px;
    tr {
      height: 50px;
      th {
        text-align: left;
        font-size: 20px;
      }
      td:nth-child(1) {
        width: 120px;
      }
      td {
        padding: 0 15px;
        font-size: 16px;
      }
    }
  }
}
// .table {
//   width: 55%;
//   border: 1px solid #000;
//   .th {
//     padding: 10px 0;
//     border-bottom: 1px solid #000;
//     .td {
//       font-size: 20px;
//       font-weight: 550;
//     }
//   }
//   .tr {
//     display: flex;
//     align-items: center;
//     justify-content: left;
//     padding: 10px 10px;
//     .td {
//       border-right: 1px solid #000;
//     }
//   }
// }
.tipinfo {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 550;
  color: #000000;
  line-height: 24px;
  margin-bottom: 21px;
}
</style>
